
import { defineComponent } from "vue";
import api, { ReceiverExport } from "../../api/backend-api";
import { getHumanDate, utcNow } from "../../util/luxonDateHelpers";
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
    msg: string;
    receiverexport: ReceiverExport;
    errors: AxiosError[];
}

export default defineComponent({
    name: "ReceiverExportForm",
    components: { ErrorBlock },
    mounted() {
        this.$nextTick(() => {
            this.callGetReceiverExport();
        });
    },
    data: (): State => {
        let receiverexport = {} as ReceiverExport;
        return {
            msg: "Receiver Export Details",
            receiverexport: receiverexport,
            errors: [],
        };
    },
    methods: {
        getHumanDate,
        utcNow,
        deleteExport() {
            const receiverexport = {
                id: this.receiverexport.id,
            } as ReceiverExport;
            api.deleteReceiverExport(receiverexport).then(() => {
                this.$router.push('/receiver/export')
            }).catch((error: AxiosError) => {
                this.errors.push(error.response?.data.message);
            })

        },
        acknowledge() {
            const receiverexport = {
                id: this.receiverexport.id,
                Exported: this.utcNow().toISO()
            } as ReceiverExport;
            api.saveReceiverExport(receiverexport).then((response) => {
                this.receiverexport = response.data
            }).catch((error: AxiosError) => {
                this.errors.push(error.response?.data.message);
            })
        },
        downloadFile(idx: number) {
            const _file = this.receiverexport.Files[idx]
            api.getReceiverExportFile(this.receiverexport.id, _file.FileId).then(response => {
                const blob = new Blob([response.data], { type: 'text/csv' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = _file.Name
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
        callGetReceiverExport() {

            this.errors = [];
            let receiverexport_id = '';
            if (typeof this.$route.params.slug != 'string') {
                throw new Error("Invalid url");
            }
            receiverexport_id = this.$route.params.slug

            api
                .getReceiverExport(receiverexport_id)
                .then((response) => {
                    this.receiverexport = response.data;
                })
                .catch((error: AxiosError) => {
                    this.errors.push(error.response?.data.message);
                });
        },
    }
});
